// const baseUrl = 'http://genset-analysis-api.zyrcsoft.com' // 测试
const baseUrl = '/api' // 内网
export const api = {
  realtimeList: baseUrl + '/water/dataV/realtimeList',//中下实时运行参数
  realtimeAvgList: baseUrl + '/water/dataV/realtimeAvgList',
  unitTrendAnalysis: baseUrl + '/water/dataV/unitTrendAnalysis',//左上图
  historyAnalysis: baseUrl + '/water/dataV/historyAnalysis',//右上图
  historyAnalysisForCompare: baseUrl + '/water/dataV/historyAnalysisForCompare',
  unitHydraulicAnalysis: baseUrl + '/water/dataV/unitHydraulicAnalysis',//中间图和表
  updateSetting: baseUrl + '/system/datav',
  getSetting: baseUrl + '/water/dataVSetting/1',
  getSystemStatus: baseUrl + '/water/dataV/getSystemStatus',//右下图
  getCode: baseUrl + '/captchaImage',
  login: baseUrl + '/login',
  unitHydraulicComparison: baseUrl + '/water/dataV/unitHydraulicComparison',//左下图
}